import { verifyPaymentStatementAPI, VerifyPaymentStatementRequestBody } from '../../../api/smartbestbuys-api'

export const verifyPaymentStatement = (
  saleOrderId: number,
  transactionId: number,
  request: VerifyPaymentStatementRequestBody,
) => {
  return verifyPaymentStatementAPI(saleOrderId)(transactionId, request)
}
